export default "__VITE_ASSET__BYVw4huY__"